import { LogLevel } from "@azure/msal-browser";

export const msalConfigB2C = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITIES],
    redirectUri: `${window.location.origin}/dashboard`,
    postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    windowHashTimeout: 9000,
    iframeHashTimeout: 9000,
    loadFrameTimeout: 9000,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
          console.log(message);
        }
      },
      logLevel: LogLevel.Verbose,
    },
  },
};

// Sign-in request
export const signinRequest = {
  authority: process.env.REACT_APP_SIGNIN_AUTHORITY,
  scopes: ["openid", "offline_access", process.env.REACT_APP_API_SCOPE],
  prompt: "login",
  redirectUri: `${window.location.origin}/dashboard`,
};

// Silent authentication request
export const silentRequest = {
  authority: process.env.REACT_APP_SILENT_AUTHORITY,
  scopes: ["openid", "offline_access", process.env.REACT_APP_API_SCOPE],
  forceRefresh: false,
};

// Sign-up request
export const signupRequest = {
  authority: process.env.REACT_APP_SIGNUP_AUTHORITY,
  scopes: ["openid", "offline_access", process.env.REACT_APP_API_SCOPE],
  prompt: "login",
  redirectUri: `${window.location.origin}/dashboard`
};

// Password reset request
export const PasswordSetupRequest = {
  authority: process.env.REACT_APP_PASSWORD_RESET_AUTHORITY,
  scopes: ["openid", "offline_access"],
  prompt: "login",
  redirectUri: `${window.location.origin}/login`,
};
 
console.log(" location.origin:", window.location.origin);
export const ChangePasswordRequest = {
  authority: process.env.REACT_APP_PASSWORD_CHANGE_AUTHORITY,
  scopes: ["openid", "offline_access"],
  prompt: "login",
  redirectUri: `${window.location.origin}/dashboard`,
};
